import { memo } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { ProgressBar, Stack } from 'src/components';
import Lives, { NumLives as _NumLives } from './Lives';
import * as S from './SessionExtrasStyles';

const msgs = defineMessages({
  correctAnswers: {
    id: 'learning_session_speed_review_session_extras_correct_answers',
  },
});

// Workaround for re-exported type ban
// https://github.com/facebook/create-react-app/issues/6054#issuecomment-481441272
export type NumLives = _NumLives;

interface SessionExtrasProps {
  numLives: NumLives;
  correctAnswers: number;
  /**
   * A number between 0 and 100 inclusive
   */
  percentageTimeLeft: number;
}

const SessionExtras = ({ numLives, correctAnswers, percentageTimeLeft }: SessionExtrasProps) => {
  const intl = useIntl();
  return (
    <Stack $direction="vertical" $spacing="s5">
      <Stack $direction="horizontal" $splitIndex={1}>
        <Lives numLives={numLives} />
      </Stack>
      <ProgressBar percentComplete={percentageTimeLeft} color="red" linear reverse />
      <Stack $direction="horizontal" $splitIndex={0}>
        <span>
          {intl.formatMessage(msgs.correctAnswers)}{' '}
          <S.CorrectAnswers>{correctAnswers}</S.CorrectAnswers>
        </span>
      </Stack>
    </Stack>
  );
};

export default memo(SessionExtras);
